<template>
  <div class="search-bar">
    <el-form :model="searchForm">
      <el-row :gutter="20">
        <el-col :span="24" :sm="20" :md="12" :lg="8">
          <el-form-item>
            <el-input
              v-model="searchForm.name"
              :placeholder="$t('SerialNumberUpgrade.searchByName')"
              prefix-icon="el-icon-search"
              :clearable="true"
              @keyup.enter="handleSearch"
              @clear="handleClear"
            >
              <template #append>
                <el-button @click="handleSearch" :loading="searchLoading" :text="$t('SerialNumberUpgrade.search')">
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        name: ''
      },
      searchLoading: false
    };
  },
  methods: {
    handleSearch() {
      this.searchLoading = true;
      try {
        this.$emit('search', this.searchForm.name);
      } catch (error) {
        console.error(error);
      } finally {
        this.searchLoading = false;
      }
    },
    resetSearch() {
      this.searchForm.name = '';
    },
    
    // 处理清除搜索
    handleClear() {
      this.searchLoading = true;
      try {
        this.$emit('search', '');
      } catch (error) {
        console.error(error);
      } finally {
        this.searchLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.search-bar {
  margin-bottom: 16px;
}
</style>